import { useEffect, useState } from "react";
import {
  deleteBanner,
  fetchAllBanners,
  updateBanner,
} from "../../firebase/fireStoreServices";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

export default function BannerList() {
  const [banners, setBanners] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    loadBanners();
  }, []);

  const loadBanners = async () => {
    const data = await fetchAllBanners();
    setBanners(data);
    console.log("BAnner Data: ", data);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Banner?")) {
      await deleteBanner(id);
      loadBanners();
    }
  };
  const handleEdit = (banner) => {
    setEditId(banner.id);
    setEditData({
      title: banner.title,
      subTitle: banner.subTitle,
      image: banner.image,
    });
  };
  const handleSave = async (id) => {
    await updateBanner(id, editData);
    setEditId(null);
    loadBanners();
  };
  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography
                variant="h5"
                mb={3}
                fontWeight="bold"
                textAlign="center"
              >
                Title
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="h5"
                mb={3}
                fontWeight="bold"
                textAlign="center"
              >
                SubTitle
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="h5"
                mb={3}
                fontWeight="bold"
                textAlign="center"
              >
                Image URL
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="h5"
                mb={3}
                fontWeight="bold"
                textAlign="center"
              >
                Actions
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {banners.map((banner) => (
            <TableRow key={banner.id}>
              <TableCell>
                {editId === banner.id ? (
                  <TextField
                    value={editData.title}
                    onChange={(e) =>
                      setEditData({ ...editData, title: e.target.value })
                    }
                  />
                ) : (
                  banner.title
                )}
              </TableCell>
              <TableCell>
                {editId === banner.id ? (
                  <TextField
                    value={editData.subTitle}
                    onChange={(e) =>
                      setEditData({ ...editData, subTitle: e.target.value })
                    }
                  />
                ) : (
                  banner.subTitle
                )}
              </TableCell>
              <TableCell>
                {editId === banner.id ? (
                  <TextField
                    value={editData.image}
                    onChange={(e) =>
                      setEditData({ ...editData, image: e.target.value })
                    }
                  />
                ) : (
                  banner.image
                )}
              </TableCell>
              <TableCell>
                {editId === banner.id ? (
                  <Button onClick={() => handleSave(banner.id)} color="success">
                    Save
                  </Button>
                ) : (
                  <Button onClick={() => handleEdit(banner)} color="primary">
                    Edit
                  </Button>
                )}
                <Button
                  onClick={() => handleDelete(banner.id)}
                  color="error"
                  sx={{ ml: 1 }}
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
